import { schema } from 'normalizr';

const hall = new schema.Entity('halls', {}, { idAttribute: 'id' });
const hallsSchema = [hall];

export default hallsSchema;



// WEBPACK FOOTER //
// ./src/normalizr-schemas/hallsSchema.js